import React from 'react';
import PropTypes from 'prop-types';

import { Text, HealthStatus } from 'components/common/Elements/Elements';

import classes from './HealthPoint.module.scss';

const HealthPoint = ({ data: { point, status } }) => {
  return (
    <>
      <Text className={classes.point}>{point}</Text>
      <HealthStatus status={status} />
    </>
  );
};

HealthPoint.propTypes = {
  data: PropTypes.shape({
    point: PropTypes.number,
    status: PropTypes.string
  })
};

export default HealthPoint;
